<template>
  <div class="login">
    <div class="row justify-content-center">
      <img width="300" src="@/assets/automato-robotics.png" class="logo" />
    </div>
    <br />
    <form @submit.prevent="Login">
      <div class="form-group row justify-content-md-center">
        <div class="col-sm-4">
          <language-switcher />
        </div>
      </div>

      <div class="form-group row justify-content-md-center">
        <label for="username" class="col-sm-2 col-form-label">{{ $t("login.username")}}</label>
        <div class="col-sm-2">
          <input
            v-model="user.username"
            type
            class="form-control"
            id="username"
            :placeholder="$t('login.username_placeholder')"
          />
        </div>
      </div>
      <div class="form-group row justify-content-md-center">
        <label
          for="exampleInputPassword1"
          class="col-sm-2 col-form-label"
        >{{ $t('login.password') }}</label>
        <div class="col-sm-2">
          <input
            v-model="user.password"
            type="password"
            class="form-control"
            id="exampleInputPassword1"
            :placeholder="$t('login.password_placeholder')"
          />
        </div>
      </div>

      <div class="row justify-content-center">
        <div class="col-sm-2" />
        <div class="col-sm-2">
          <input type="submit" class="btn btn-primary full-width" :value="$t('global.submit')" />
        </div>
      </div>
    </form>
  </div>
</template>

<style>
.full-width {
  width: 100%;
}
.logo {
  margin-bottom: 20px;
  text-align: center;
}
</style>
<script>
// @ is an alias to /src
import { mapState, mapActions } from "vuex";
import RosService from "@/services/RosService.js";
import LanguageSwitcher from "../components/LanguageSwitcher.vue";

export default {
  name: "Login",
  data() {
    return {
      user: {}
    };
  },
  components: {
    LanguageSwitcher
  },
  computed: mapState({
    event: state => state.chat["secs"]
  }),
  methods: {
    async Login() {
      const result = await RosService.login(this.user);
      if (result) {
        console.log("logged in");
        this.$store.dispatch("login", this.user);
        this.$router.push("Farms");
      } else {
        alert(this.$t("login.error"));
      }
    }
  }
};
</script>
